import { render, staticRenderFns } from "./DraftTab.vue?vue&type=template&id=fa99228c"
import script from "./DraftTab.vue?vue&type=script&lang=js"
export * from "./DraftTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports